var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22295 23.0808C12.0654 23.0808 15.1803 19.9585 15.1803 16.1068C15.1803 12.2552 12.0654 9.13281 8.22295 9.13281C4.38052 9.13281 1.26562 12.2552 1.26562 16.1068C1.26562 19.9585 4.38052 23.0808 8.22295 23.0808Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0955 7.62876C21.9216 7.62876 23.402 6.14486 23.402 4.31438C23.402 2.4839 21.9216 1 20.0955 1C18.2694 1 16.7891 2.4839 16.7891 4.31438C16.7891 6.14486 18.2694 7.62876 20.0955 7.62876Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.744 19.4217C29.5701 19.4217 31.0504 17.9378 31.0504 16.1073C31.0504 14.2769 29.5701 12.793 27.744 12.793C25.9179 12.793 24.4375 14.2769 24.4375 16.1073C24.4375 17.9378 25.9179 19.4217 27.744 19.4217Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0955 30.4608C21.9216 30.4608 23.402 28.9769 23.402 27.1464C23.402 25.3159 21.9216 23.832 20.0955 23.832C18.2694 23.832 16.7891 25.3159 16.7891 27.1464C16.7891 28.9769 18.2694 30.4608 20.0955 30.4608Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8844 25.7426L12.0625 21.9219",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7656 10.2993L17.5875 6.47852",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1797 16.1074H24.1347",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.be3543d08af5a99f123345faea83b743.svg";
export { ForwardRef as ReactComponent };